/* ============================================================
   Global JavaScript - Juliane Porter Art
   Navigation, gallery, and UI interactions
   ============================================================ */

(function() {
  'use strict';

  /* --- Navigation Dropdown --- */
  function initNavigation() {
    const dropdowns = document.querySelectorAll('.nav-dropdown');

    dropdowns.forEach(function(dropdown) {
      const link = dropdown.querySelector('.nav-link');
      const submenu = dropdown.querySelector('.nav-submenu');
      if (!submenu) return;
      let closeTimer = null;

      // Show on hover (desktop)
      dropdown.addEventListener('mouseenter', function() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        closeAllDropdowns(dropdown);
        this.classList.add('active');
      });

      dropdown.addEventListener('mouseleave', function() {
        closeTimer = setTimeout(() => {
          this.classList.remove('active');
        }, 180);
      });

      submenu.addEventListener('mouseenter', function() {
        if (closeTimer) {
          clearTimeout(closeTimer);
          closeTimer = null;
        }
        dropdown.classList.add('active');
      });

      submenu.addEventListener('mouseleave', function() {
        closeTimer = setTimeout(() => {
          dropdown.classList.remove('active');
        }, 180);
      });

      // Toggle on click (mobile/touch)
      if (link) {
        link.addEventListener('click', function(e) {
          if (window.innerWidth <= 749 || link.getAttribute('href') === '#') {
            e.preventDefault();
            const isActive = dropdown.classList.contains('active');
            closeAllDropdowns(dropdown);
            if (!isActive) {
              dropdown.classList.add('active');
            }
          }
        });
      }
    });

    // Close dropdowns when clicking outside
    document.addEventListener('click', function(e) {
      if (!e.target.closest('.nav-dropdown')) {
        closeAllDropdowns();
      }
    });

    function closeAllDropdowns(exceptDropdown) {
      dropdowns.forEach(function(d) {
        if (exceptDropdown && d === exceptDropdown) return;
        d.classList.remove('active');
      });
    }
  }

  /* --- Product Card Gallery (arrow navigation) --- */
  function initCardGalleries() {
    document.body.addEventListener('click', function(e) {
      const arrow = e.target.closest('.gallery-arrow');
      if (!arrow) return;

      e.preventDefault();
      e.stopPropagation();

      const card = arrow.closest('.product-card-gallery');
      if (!card) return;

      const images = card.querySelectorAll('.card__image');
      if (images.length <= 1) return;

      let activeIndex = 0;
      images.forEach(function(img, idx) {
        if (img.classList.contains('active')) activeIndex = idx;
      });

      var nextIndex;
      if (arrow.classList.contains('prev')) {
        nextIndex = (activeIndex - 1 + images.length) % images.length;
      } else {
        nextIndex = (activeIndex + 1) % images.length;
      }

      // Smooth crossfade
      images[activeIndex].classList.remove('active');
      images[activeIndex].style.opacity = '0';
      images[activeIndex].style.zIndex = '0';

      images[nextIndex].classList.add('active');
      images[nextIndex].style.opacity = '1';
      images[nextIndex].style.zIndex = '1';
    });
  }

  /* --- AOS Init --- */
  function initAOS() {
    if (typeof AOS !== 'undefined') {
      AOS.init({
        duration: 800,
        easing: 'ease-out',
        once: true,
        offset: 60,
        disable: function() {
          return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        }
      });
    }
  }

  /* --- Smooth Scroll --- */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (href === '#') return;
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  /* --- Init --- */
  function init() {
    initNavigation();
    initCardGalleries();
    initAOS();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
